<template>
    <div class="contact">
        <div class="flex__center__center column wrap">
            <p class="title">CONTACT US</p>
            <div class="flex__center__center">
                <span>——&emsp;</span>
                <span class="fs_38 c_1a">联系我们</span>
                <span>&emsp;——</span>
            </div>
        </div>
        <div class="img-box" @click="link">
            <img :src="infos.carousel[0].img_path" alt="">
        </div>
        <div class="list">
            <div class="flex__center column item">
                <p class="fs_26 c_b3 lh_40">联系方式</p>
                <div>
                    <a class="fs_32 c_4d lh_40" :href="'tel:'+infos.seat_machine">{{infos.seat_machine}}</a>
                    <a class="fs_32 c_4d lh_40" :href="'tel:'+infos.telephone">{{infos.telephone}}</a>
                </div>
            </div>
            <div class="flex__center column item">
                <p class="fs_26 c_b3 lh_40">客服微信</p>
                <p class="fs_32 c_4d lh_40">{{infos.wechat}}</p>
            </div>
            <div class="flex__center column item">
                <p class="fs_26 c_b3 lh_40">公司地址</p>
                <p class="fs_32 c_4d lh_40">{{infos.address}}</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "Contact",
    data(){
        return{
            infos:{
                carousel:[{}]
            }
        }
    },
    methods:{
        link(){
            window.location.href=this.infos.carousel[0].url;
        }
    },
    mounted(){
        this.axios.post('/wechat.php/Vip/contactUs').then(
            res=>{
                if(res.data.code==1){
                    this.infos=res.data.data.data;
                }
            }
        )
    }

}
</script>
<style scoped>
.contact{
    position: fixed;
    top: 0;
    bottom: 0;
    padding: 0 45px 30px;
    background: #fff;
    overflow: auto;
}
.title{
    font-size: 70px;
    color: #e6e6e6;
    line-height: 90px;
    font-weight:normal;
}
.img-box{
    padding: 40px 0 10px;
}
.img-box img{
    width: 660px;
    height: 260px;
}
.item{
    padding: 30px 30px;
    margin-top: 10px;
    background: #f5f5f5;
}
</style>



// WEBPACK FOOTER //
// src/pages/mine/Contact.vue